import type { SimpleChanges } from '@angular/core';
import { ChangeDetectionStrategy, Component, Input, output, inject } from '@angular/core';

import { TranslatePipe } from '@core/i18n-legacy';
import { IconComponent, DropdownItemComponent } from '@core/user-interface-legacy';

import { WysiwygAction } from '../../../adapter/wysiwyg-adapter.types';
import type { Placeholder, PlaceholderId } from '../../placeholder';
import { PlaceholderCategorySelectDropdownComponent } from '../../placeholder-category-select-dropdown/placeholder-category-select-dropdown.component';
import { PlaceholderService } from '../../placeholder.service';
import type { WysiwygPlaceholderAction } from '../wysiwyg-placeholder.types';
import { ActionType } from '../wysiwyg-placeholder.types';

@Component({
  selector: 'rt-wysiwyg-placeholder-dropdown',
  styleUrls: ['./wysiwyg-placeholder-dropdown.component.less'],
  templateUrl: './wysiwyg-placeholder-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PlaceholderCategorySelectDropdownComponent,
    DropdownItemComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class WysiwygPlaceholderDropdownComponent {
  private readonly placeholderService = inject(PlaceholderService);

  @Input() public active: Placeholder;
  @Input() public placeholders: Placeholder[];

  public action = output<WysiwygPlaceholderAction>();
  public filteredPlaceholders: Placeholder[];

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.placeholders) {
      this.filteredPlaceholders = changes.placeholders.currentValue.filter(
        ({ id }: { id: PlaceholderId }) =>
          !this.placeholderService.deprecatedCollection.includes(id),
      );
    }
  }

  public deletePlaceholder(event: Event, placeholder: Placeholder) {
    event.stopPropagation();
    event.preventDefault();
    this.emitPlaceholderDelete(placeholder);
  }

  public emitPlaceholderChange(placeholder: Placeholder): void {
    this.action.emit(new WysiwygAction(ActionType.PlaceholderChange, placeholder));
  }

  public emitPlaceholderDelete(placeholder: Placeholder): void {
    this.action.emit(new WysiwygAction(ActionType.PlaceholderDelete, placeholder));
  }
}
